import CountriesListBody from './CountriesListBody';

const View = (props) => <CountriesListBody {...props} />;

export default View;
